import { BaseIcon, type BaseIconProps } from '@fountain/ripple/icon';
import React, { forwardRef } from 'react';

// Source: Material-UI FiberManualRecord.
export const StatusDotIcon = forwardRef<SVGSVGElement, BaseIconProps>(
  function StatusDotIcon(props, ref) {
    return (
      <BaseIcon
        ref={ref}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke="none"
        {...props}
      >
        <circle cx="12" cy="12" r="8" />
      </BaseIcon>
    );
  },
);
